import BaseAddEditModal from '../../../components/base/BaseAddEditModal';
import React from 'react';

const AddEditForceUpdateModal = ({ isOpen, isEdit, onClose, initialData, onSave }) => {
  
  const dataStructure = {
    platform: { type: 'select', label: 'Platform', options: [
        {label:'iOS',value:'ios'},
        {label:'Android',value:'android'},
    ],required: true },
    existing_version: { type: 'text', label: 'Update Version', required: true },
    mandatory_update_version: { type: 'text', label: 'Mandatory Update Version', required: false },
    effective_date: { type: 'dateTime', label: 'Effective Date', required: false },
  };

  const { platform } = dataStructure;
  const { options } = platform;
  const defaultPlatform = options.length > 1 ? {'platform': options[0].value} : null;
  if (!initialData || initialData === ' ') {
    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);
    initialData = {...defaultPlatform, effective_date: todayStart };
  }

  return (
    <BaseAddEditModal
      isOpen={isOpen}
      isEdit={isEdit}
      onClose={onClose}
      initialData={initialData}
      onSave={onSave}
      dataStructure={dataStructure}
      tableName="force_update_history"
      // mainKey='tier'
    />
  );
};
export default AddEditForceUpdateModal;










